function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M1924 220.852C999.5-69.055 499 1188.87-413 449.791V0h2337v220.852z",
  fill: "url(#hero-backdrop_svg__paint0_linear)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M1924 211.193C999.5-66.035 499 1136.88-413 430.121V0h2337v211.193z",
  fill: "url(#hero-backdrop_svg__paint1_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero-backdrop_svg__paint0_linear",
  x1: 603.988,
  y1: 183.55,
  x2: 608.563,
  y2: 680.732,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#807EE6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4B90D0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero-backdrop_svg__paint1_linear",
  x1: 603.988,
  y1: 175.523,
  x2: 608.171,
  y2: 650.966,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#807EE6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4B90D0"
})));

function SvgHeroBackdrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    viewBox: "0 0 1440 686",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB2aWV3Qm94PSIwIDAgMTQ0MCA2ODYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIG9wYWNpdHk9IjAuMSIgZD0iTTE5MjQgMjIwLjg1MkM5OTkuNSAtNjkuMDU1IDQ5OSAxMTg4Ljg3IC00MTMgNDQ5Ljc5MVYwSDE5MjRWMjIwLjg1MloiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcikiLz4KPHBhdGggb3BhY2l0eT0iMC4xIiBkPSJNMTkyNCAyMTEuMTkzQzk5OS41IC02Ni4wMzUxIDQ5OSAxMTM2Ljg4IC00MTMgNDMwLjEyMVYwSDE5MjRWMjExLjE5M1oiIGZpbGw9InVybCgjcGFpbnQxX2xpbmVhcikiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjYwMy45ODgiIHkxPSIxODMuNTUiIHgyPSI2MDguNTYzIiB5Mj0iNjgwLjczMiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjODA3RUU2Ii8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzRCOTBEMCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MV9saW5lYXIiIHgxPSI2MDMuOTg4IiB5MT0iMTc1LjUyMyIgeDI9IjYwOC4xNzEiIHkyPSI2NTAuOTY2IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM4MDdFRTYiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNEI5MEQwIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgHeroBackdrop as ReactComponent };